import React from "react";
import { ActionButton } from "../ActionButton";

interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  actionText?: string;
  onAction?: () => void;
  actionDisabled?: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  actionText,
  onAction,
  actionDisabled = false,
}) => {
  return (
    <div className="text-center py-16 px-8">
      <div className="mb-6 flex justify-center text-gray-400 dark:text-slate-500 [&>.MuiSvgIcon-root]:text-7xl [&>.MuiSvgIcon-root]:md:text-8xl">
        {icon}
      </div>
      <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">{title}</h3>
      <p className="text-lg text-gray-600 dark:text-slate-400 mb-8 max-w-md mx-auto">
        {description}
      </p>
      {actionText && onAction && (
        <ActionButton
          onClick={onAction}
          disabled={actionDisabled}
          icon="+"
          size="sm"
          className="mx-auto"
        >
          {actionText}
        </ActionButton>
      )}
    </div>
  );
};
